import React from "react";
import { AlertTriangle, Apple, Sparkles, Thermometer, Clock, Heart, Trash2 } from "lucide-react";

// ─── Tip type config ──────────────────────────────────────────────────────────
const TIP_CONFIG = {
  nutrition:  { icon: Apple,         bg: "bg-[#E8F0E8]", accent: "text-[#4A6B4E]",  border: "border-[#7B9E7F]/20" },
  warning:    { icon: AlertTriangle,  bg: "bg-[#FDECEA]", accent: "text-[#BC4749]",  border: "border-[#BC4749]/20" },
  storage:    { icon: Thermometer,    bg: "bg-[#FEF9EC]", accent: "text-[#8B6914]",  border: "border-[#E9C46A]/30" },
  reminder:   { icon: Clock,          bg: "bg-[#EEF2FF]", accent: "text-[#5B6DA8]",  border: "border-[#7B8ECF]/20" },
  default:    { icon: Sparkles,       bg: "bg-[#FFF0EC]", accent: "text-[#B5654B]",  border: "border-[#D4856B]/20" },
};

// Optional props drive behaviour:
//   onExpand      — presence makes the card clickable (nothing to expand => not clickable)
//   onToggleLike  — renders the Heart action; onRemove renders Trash2 instead
function TipCard({ tip, idx, expanded, onExpand, liked, onToggleLike, onRemove }) {
  const cfg = TIP_CONFIG[tip.type] || TIP_CONFIG.default;
  const Icon = cfg.icon;
  const clickable = typeof onExpand === "function";
  return (
    <div
      data-testid={`tip-card-${idx}`}
      onClick={clickable ? (e) => { e.stopPropagation(); onExpand(idx); } : undefined}
      className={`w-full rounded-2xl p-4 border transition-all duration-200 ${clickable ? "cursor-pointer" : ""} ${cfg.bg} ${cfg.border} flex items-start gap-3`}
    >
      <div className={`w-9 h-9 rounded-full bg-white/70 flex items-center justify-center shrink-0 ${cfg.accent}`}>
        <Icon className="w-4 h-4" strokeWidth={1.5} />
      </div>
      <div className="flex-1 min-w-0">
        <p className={`font-body font-semibold text-sm leading-snug ${cfg.accent} ${expanded || !clickable ? "" : "truncate"}`}>{tip.title}</p>
        {expanded && (
          <p className="font-body text-xs text-[#6B705C] leading-relaxed mt-1.5">{tip.message}</p>
        )}
      </div>
      {onToggleLike ? (
        <button
          data-testid={`tip-like-${idx}`}
          onClick={(e) => { e.stopPropagation(); onToggleLike(idx); }}
          className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${
            liked ? "bg-[#D4856B] text-white" : "bg-white/70 text-[#A5A58D] hover:bg-white"
          }`}
        >
          <Heart className="w-4 h-4" strokeWidth={1.5} fill={liked ? "currentColor" : "none"} />
        </button>
      ) : onRemove ? (
        <button
          data-testid={`tip-remove-${idx}`}
          onClick={(e) => { e.stopPropagation(); onRemove(idx); }}
          className="w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all bg-white/70 text-[#A5A58D] hover:bg-[#BC4749]/10 hover:text-[#BC4749]"
        >
          <Trash2 className="w-4 h-4" strokeWidth={1.5} />
        </button>
      ) : null}
    </div>
  );
}

export default TipCard;
